import styled from 'styled-components'

export const PageContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  margin-right: auto;
  margin-left: auto;
  position: relative;
  overflow: hidden;
  //display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({ isModalOpen }) => (isModalOpen ? '#EBEBEB' : 'unset')};
  display: ${({ isDisplay }) => (isDisplay === false ? 'none' : 'flex')};
  visibility: ${({ isDisplay }) =>
    isDisplay === false ? 'hidden' : 'visible'};
`

export const PageContentContainer = styled.div`
  pointer-events: ${({ isModalOpen }) => (isModalOpen ? 'none' : 'unset')};
  opacity: ${({ isModalOpen }) => (isModalOpen ? '0.4' : '1')};
  padding: 0 16px;
  width: 100%;
`
export const PageHeadingWrapper = styled.div`
  padding: 32px 0px 16px 0px;
`

export const PagePad = styled.div`
  height: ${({ padHeight }) => (padHeight ? padHeight : '0px')};
  width: 100%;
`

export const LoadingPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
